@use '../../../../../scss/settings/colors.scss';

.employment_info_text {

}

.disclaimer_block {
  padding: 16px;
  background-color: colors.$gray-variant-20;
  border-radius: 8px;
}